import React from 'react';
import { Label } from 'fw/components';
import { Col, Modal, FormGroup, Row, Button, Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { DatePicker } from 'fw/forms';
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';
import Moment from 'moment';
import Loading from 'layouts/public/loading/Loading'

class ChangeInitialDatePopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            dirty: false,
            busy: false,
            disabledSave: true,
            initialDate: props.initialDate
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible
        });
    }

    close = (success) => {
        this.setState({
            visible: false,
        }, function () {
            this.props.onClose(success);
        });
    }

    renderIndicator = () => {
        if (this.state.dirty)
            return <Glyphicon glyph="pencil" className="pull-right" style={{ color: "red" }} />
        else
            return null;
    }

    dirt = () => {
        this.setState({
            dirty: true
        });
    }

    getBusy = () => {
        this.setState({
            busy: true
        });
    }

    onChange = (value) => {
        var date = Moment(value, ["D MMM YYYY", "DD MMM YYYY"], true);
        if (!date.isValid()) {
            this.setState({
                disabledSave: true,
                initialDate: value
            });
            return;
        }

        this.setState({
            disabledSave: false,
            initialDate: value
        });
        this.dirt()
    };

    handleSave = () => {
        const rqChange = {
            initialCertificationDate: this.state.initialDate,
            certificationId: this.props.certificationId
        };

        // Spinner
        this.getBusy();

        API.Admin.post('/certification/changeInitialCertificationDate', rqChange,
            {
                success: (sr) => {
                    Notifications.success(sr.message);
                    this.setState({
                        busy: false,
                        dirty: false
                    });
                    this.close(true);
                },
                error: (sr) => {
                    Notifications.error(sr.error.errorMessage);
                }
            });
    }

    render() {
        let me = this;
        return (
            <Modal show={this.state.visible} onHide={this.close}
                dialogClassName="modal-30w">
                <Modal.Header>
                    <h3 style={{ marginTop: "10px", marginBottom: "0px" }}>
                        Change Initial Certification Date
                        <br />
                        <small>
                            This action will change the Initial Certification Date of the Company.
                            If this is the only certification for the Company, this action will also change the Expiration Date and generate a new Certificate for the VOB within VOCS.
                        </small>
                    </h3>
                </Modal.Header>
                <Modal.Body>
                    <React.Fragment>
                        {this.state.busy ?
                            <Loading />
                            :
                            <Row>
                                <Col md={12}>
                                    {this.props.initialDate == null || this.props.certificationId == null ?
                                        <React.Fragment>
                                            <Row>
                                                <Col md={12}>
                                                    <h5><em>This action cannot be performed</em></h5>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                        :
                                        <React.Fragment>
                                            <Row>
                                                <Col md={1}>
                                                </Col>
                                                <Col md={10}>

                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                </Col>
                                                <Col md={4}>
                                                    <FormGroup>
                                                        <Label htmlFor='initialDate' required>
                                                            Initial Certification Date
                                                        </Label>
                                                        <DatePicker
                                                            required
                                                            placeholder="Initial Date"
                                                            managed={true}
                                                            value={this.state.initialDate}
                                                            onFieldChange={e => me.onChange(e)}
                                                            showTime={false}
                                                            disabled={this.state.busy}
                                                            className='dpThin'
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col md={3}>
                                                    <span className="pull-right">
                                                        {this.renderIndicator()}
                                                    </span>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <br />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={1}>
                                                </Col>
                                                <Col md={10}>
                                                    <div className="alert" style={{ textAlign: "center", color: "#721c24", backgroundColor: "#f8d7da", borderColor: "#f5c6cb" }}>
                                                        <strong>
                                                            <FontAwesomeIcon icon={faExclamationTriangle} size="1x" />
                                                            &nbsp;&nbsp;Attention! This action cannot be undone.
                                                        </strong>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    }
                                </Col>
                            </Row>
                        }
                    </React.Fragment>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveChanges" bsStyle="success"
                        disabled={!this.state.dirty || this.state.busy || this.state.disabledSave} onClick={this.handleSave}>Save Changes</Button>
                    <Button onClick={this.close} disabled={this.state.busy}>Close</Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ChangeInitialDatePopUp;


// WEBPACK FOOTER //
// ./src/areas/admin/connectToVOB/ChangeInitialDatePopUp.js